import { Component, OnInit, ViewChild, TemplateRef, ViewContainerRef } from '@angular/core';

import { StatusMinhasComprasList } from 'src/app/shared/enums/status-minhas-compras-list.enum';
import { PedidoService } from 'src/app/services/pedido.service';
import { Auth } from 'src/app/models/auth';
import { SituacaoCompra } from 'src/app/shared/enums/situacao-compra.enum';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { PedidoAlerta } from 'src/app/models/pedido-alerta';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { TipoPedidoAlerta } from 'src/app/shared/enums/tipo-pedido-alerta.enum';
import { environment } from 'src/environments/environment';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-minhas-compras-list',
  templateUrl: './minhas-compras-list.component.html',
  styleUrls: ['./minhas-compras-list.component.css']
})
export class MinhasComprasListComponent implements OnInit {

  public showStatusMinhasComprasList: number;
  public StatusMinhasComprasList = StatusMinhasComprasList;
  private currentUser: Auth;
  private currentPedidoAlerta: PedidoAlerta;
  public filtroPesquisa: string;

  constructor(
    private alertService: NewAlertService,
    private pedidoService: PedidoService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private pedidoDataService: PedidoDataService) {  }

  ngOnInit() {

    if(sessionStorage.getItem('statusMinhasComprasList') != null){
      this.showStatusMinhasComprasList = parseInt(sessionStorage.getItem('statusMinhasComprasList'));
      sessionStorage.removeItem('statusMinhasComprasList');
    } else{
      this.showStatusMinhasComprasList = this.StatusMinhasComprasList.ComprasEmAndamento;
    }
    this.currentUser = this.authenticationService.currentUserValue;
    // alertas para pedidos não processados e processados parcialmente

    // verificar se a cedente possuí pedidos não processados
    const expirationDate = new Date();
    expirationDate.setMilliseconds(expirationDate.getMilliseconds() + environment.DURACAO_PEDIDO_ALERTA);
    this.currentPedidoAlerta = new PedidoAlerta(TipoPedidoAlerta.TudoCerto, true, expirationDate);

    this.pedidoService.getPurcharses([SituacaoCompra.Criado, SituacaoCompra.ProcessamentoIniciado],this.currentUser.token.assignorGuid, 0, '10').subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          if (response.result.purchases.some(x => x.situacaoId === SituacaoCompra.ParcialmenteProcessado)) {
            this.currentPedidoAlerta.tipo = TipoPedidoAlerta.HaPedidosParcialmenteProcessados;
          }
          this.pedidoDataService.setCurrentPedidoAlertaValue(this.currentPedidoAlerta);
          //this.alertService.showPedidoAlerta(this.currentPedidoAlerta.tipo, true);
        }
      }
    );




  }

}

